/**
 * @generated SignedSource<<eaf67578607591ad094137391c81b681>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type newShipmentOneDeliveryQuery$variables = Record<PropertyKey, never>;
export type newShipmentOneDeliveryQuery$data = {
  readonly onedeliveryProfile: {
    readonly " $fragmentSpreads": FragmentRefs<"ShippingAddressFragment">;
  } | null | undefined;
};
export type newShipmentOneDeliveryQuery = {
  response: newShipmentOneDeliveryQuery$data;
  variables: newShipmentOneDeliveryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "newShipmentOneDeliveryQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "OnedeliveryProfile",
        "kind": "LinkedField",
        "name": "onedeliveryProfile",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ShippingAddressFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "newShipmentOneDeliveryQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "OnedeliveryProfile",
        "kind": "LinkedField",
        "name": "onedeliveryProfile",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "baceId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Hub",
            "kind": "LinkedField",
            "name": "preferredHub",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "HubMeta",
                "kind": "LinkedField",
                "name": "meta",
                "plural": false,
                "selections": [
                  (v0/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Warehouse",
            "kind": "LinkedField",
            "name": "warehouse",
            "plural": false,
            "selections": [
              (v0/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "street",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "postalCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "city",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6c0274038521b44d47dd435710dbb6d7",
    "id": null,
    "metadata": {},
    "name": "newShipmentOneDeliveryQuery",
    "operationKind": "query",
    "text": "query newShipmentOneDeliveryQuery {\n  onedeliveryProfile {\n    ...ShippingAddressFragment\n  }\n}\n\nfragment ShippingAddressFragment on OnedeliveryProfile {\n  baceId\n  preferredHub {\n    meta {\n      name\n    }\n  }\n  warehouse {\n    name\n    street\n    postalCode\n    city\n  }\n}\n"
  }
};
})();

(node as any).hash = "dbae3f6e0d3be07fb525b56e80b9996c";

export default node;
